module.exports = __webpack_public_path__ + "static/img/HOT MELT FILM products discription_deskstop.e419e95b.jpg";